export default "__VITE_ASSET__DpqeDM0R__"